import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Modal from "component/Modal";
import FileInput from 'component/FileInput';
import ListSelectField from 'component/priceBanner/selects/ListSelectField';
import SupplyItemsNotFoundBox from 'component/ircListsSupply/SupplyItemsNotFoundBox';
import 'container/priceBanner/styles.css';
import * as pricebannerListActions from 'action/pricebannerList';
import ApiRequest from 'utils/ApiRequest';
import API from 'constants/api';
import {
  parsePriceBannerProductCsvWithStores,
  getAddProductCsvTemplate,
  filterBranchMapsForProductLms,
  PRICEBANNER_INVALID_STORES_I18N_KEY,
  CMPM_PRODUCT_EXTRAS_STORAGE_KEY,
  CLUBE_LEROY_PRODUCT_EXTRAS_STORAGE_KEY,
  getProductExtrasStorageKeyByTheme,
} from 'utils/priceBannerCsvWithStores';

export function AddProductModal({
  open,
  onOpenChange,
  onSave,
  user,
  initialData,
  title,
  validateProducts,
  validateBranches,
  listName,
  translate
}) {
  const [selectedList, setSelectedList] = useState(null);
  const [listThemeCode, setListThemeCode] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [loadingCsv, setLoadingCsv] = useState(false);
  const [errorText, setErrorText] = useState('');
  const [isValidCsv, setIsValidCsv] = useState(null);
  const [errorOnStruct, setErrorOnStruct] = useState(false);
  const [cleanFile, setCleanFile] = useState(true);
  const [errors, setErrors] = useState({
    list: false,
    file: false
  });
  const [validationError, setValidationError] = useState('');
  const [extractedProducts, setExtractedProducts] = useState([]);
  const [invalidProducts, setInvalidProducts] = useState([]);
  const [validProducts, setValidProducts] = useState([]);
  const [validProductsWithDescriptions, setValidProductsWithDescriptions] = useState({});
  const [showValidationResults, setShowValidationResults] = useState(false);
  const [validationComplete, setValidationComplete] = useState(false);
  const [duplicatesMessage, setDuplicatesMessage] = useState('');
  const [progressPercentage, setProgressPercentage] = useState(0);
  const [progressInfo, setProgressInfo] = useState({ processed: 0, total: 0, originalTotal: 0, currentBatch: 0, totalBatches: 0 });
  const [retryLoading, setRetryLoading] = useState(false);
  const [branchesFromFile, setBranchesFromFile] = useState([]);
  const [productBranchesByLm, setProductBranchesByLm] = useState({});
  const [productBranchExtrasByLm, setProductBranchExtrasByLm] = useState({});
  if (!open) return null;

  useEffect(() => {
    if (!initialData) {
      setSelectedList(null);
      setUploadedFile(null);
      setLoadingCsv(false);
      setErrorText('');
      setIsValidCsv(null);
      setErrorOnStruct(false);
      setCleanFile(true);
      setExtractedProducts([]);
      setInvalidProducts([]);
      setValidProducts([]);
      setValidProductsWithDescriptions({});
      setShowValidationResults(false);
      setValidationError('');
      setValidationComplete(false);
      setProgressPercentage(0);
      setProgressInfo({ processed: 0, total: 0, originalTotal: 0, currentBatch: 0, totalBatches: 0 });
      setRetryLoading(false);
      setBranchesFromFile([]);
      setProductBranchesByLm({});
      setProductBranchExtrasByLm({});
      try {
        sessionStorage.removeItem(CMPM_PRODUCT_EXTRAS_STORAGE_KEY);
        sessionStorage.removeItem(CLUBE_LEROY_PRODUCT_EXTRAS_STORAGE_KEY);
      } catch (e) {
        // ignore
      }
      return;
    }

    if (initialData.listId) {
      setSelectedList({
        value: initialData.listId,
        label: initialData.listName || ''
      });
    }

    if (initialData.file) {
      setUploadedFile(initialData.file);
      setIsValidCsv(true);
    }

    if (initialData.validProducts) {
      setValidProducts(initialData.validProducts);
    }

    if (initialData.extractedProducts) {
      setExtractedProducts(initialData.extractedProducts);
    }

    if (initialData.validProductsWithDescriptions) {
      setValidProductsWithDescriptions(initialData.validProductsWithDescriptions);
    }

    if (initialData.showValidationResults !== undefined) {
      setShowValidationResults(initialData.showValidationResults);
    }

    if (initialData.validationComplete !== undefined) {
      setValidationComplete(initialData.validationComplete);
    }
    if (initialData.branchesFromFile) {
      setBranchesFromFile(initialData.branchesFromFile);
    }
    if (initialData.productBranchesByLm) {
      setProductBranchesByLm(initialData.productBranchesByLm);
    }
    if (initialData.productBranchExtrasByLm) {
      setProductBranchExtrasByLm(initialData.productBranchExtrasByLm);
    }
  }, [initialData]);
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const listId = urlParams.get('listId');

    if (listId && !selectedList) {
      const fetchListData = async () => {
        try {
          const api = new ApiRequest(user.dsToken);
          const response = await api.get(API.FETCH_PRICEBANNER_LISTS);

          if (response && response.data && Array.isArray(response.data)) {
            const foundList = response.data.find(list =>
              String(list.idPriceBannerList || list.id) === String(listId)
            );

            if (foundList) {
              // Isso garante que o template "compre + pague - crédito" seja baixado corretamente.
              setListThemeCode(foundList.themeCode || null);

              setSelectedList({
                value: listId,
                label: foundList.name || foundList.listName || listName || `Lista ${listId}`,
                idBranches: foundList.idBranches,
                dtStart: foundList.dtStart,
                dtEnd: foundList.dtEnd,
                fullData: { themeCode: foundList.themeCode }
              });
              return;
            }
          }
        } catch (error) {
          // Ignora e usa fallback abaixo
        }

        setListThemeCode(null);
        setSelectedList({
          value: listId,
          label: listName || `Lista ${listId}`
        });
      };

      fetchListData();
    }
  }, [listName, user?.dsToken, selectedList]);
  useEffect(() => {
    if (open && !initialData) {
      setErrors({
        list: false,
        file: false
      });
      setLoadingCsv(false);
      setErrorText('');
      setIsValidCsv(null);
      setErrorOnStruct(false);
      setCleanFile(true);
      setExtractedProducts([]);
      setInvalidProducts([]);
      setValidProducts([]);
      setValidProductsWithDescriptions({});
      setShowValidationResults(false);
      setValidationError('');
      setValidationComplete(false);
      setProgressPercentage(0);
      setProgressInfo({ processed: 0, total: 0, originalTotal: 0, currentBatch: 0, totalBatches: 0 });
      setRetryLoading(false);

      const urlParams = new URLSearchParams(window.location.search);
      const listId = urlParams.get('listId');
      if (!listId) {
        setSelectedList(null);
      }
    }

    if (open && initialData) {
      setErrors({
        list: false,
        file: false
      });
      setLoadingCsv(false);
      setErrorText('');
      setErrorOnStruct(false);
      setValidationError('');
      setProgressPercentage(0);
      setProgressInfo({ processed: 0, total: 0, originalTotal: 0, currentBatch: 0, totalBatches: 0 });
      setRetryLoading(false);
    }
  }, [open, initialData]);


  const validateCsv = (file) => {
    if (file.type !== 'text/csv') {
      setErrorText(translate('price.banner.csvformat'));
      return false;
    }
    const fileSize = file.size;
    const maxSize = 5 * 1024 * 1024;
    if (fileSize > maxSize) {
      setErrorText(translate('price.banner.file.size.invalid'));
      return false;
    }
    if (fileSize === 0) {
      setErrorText(translate('price.banner.file.empty'));
      return false;
    }
    return true;
  };
  const readCsv = async (file) => {
    const reader = new FileReader();
    reader.onload = async ({ target }) => {
      try {
        const parsed = parsePriceBannerProductCsvWithStores(
          target.result,
          listThemeCode,
          translate
        );

        if (!parsed.ok) {
          setErrorText(parsed.errorMessage);
          setErrorOnStruct(true);
          setLoadingCsv(false);
          return;
        }

        setExtractedProducts(parsed.codes);
        setBranchesFromFile(parsed.branchesFromFile || []);
        setProductBranchesByLm(parsed.productBranchesByLm || {});
        setProductBranchExtrasByLm(parsed.productBranchExtrasByLm || {});

        const productExtrasStorageKey = getProductExtrasStorageKeyByTheme(listThemeCode);
        if (productExtrasStorageKey) {
          if (Object.keys(parsed.productExtrasMap || {}).length > 0) {
            sessionStorage.setItem(productExtrasStorageKey, JSON.stringify(parsed.productExtrasMap));
          } else {
            sessionStorage.removeItem(productExtrasStorageKey);
          }
          [CMPM_PRODUCT_EXTRAS_STORAGE_KEY, CLUBE_LEROY_PRODUCT_EXTRAS_STORAGE_KEY]
            .filter(key => key !== productExtrasStorageKey)
            .forEach(key => sessionStorage.removeItem(key));
        } else {
          sessionStorage.removeItem(CMPM_PRODUCT_EXTRAS_STORAGE_KEY);
          sessionStorage.removeItem(CLUBE_LEROY_PRODUCT_EXTRAS_STORAGE_KEY);
        }

        setLoadingCsv(true);

        const branchCodes = parsed.branchCodesFromFile || parsed.branchesFromFile || [];
        const branchesValid = await validateStoresFromCsv(branchCodes);
        if (!branchesValid) {
          return;
        }

        if (parsed.codes.length > 0) {
          await validateProductsOnUpload(
            parsed.codes,
            parsed.duplicatesRemoved,
            parsed.originalCodesLength
          );
        } else {
          setLoadingCsv(false);
        }
      } catch (error) {
        setErrorText('Erro ao processar o arquivo');
        setErrorOnStruct(true);
        setLoadingCsv(false);
      }
    };
    reader.readAsText(file);
  };

  const failInvalidStoresValidation = () => {
    setErrorText(translate(PRICEBANNER_INVALID_STORES_I18N_KEY));
    setErrorOnStruct(true);
    setLoadingCsv(false);
    setShowValidationResults(false);
    setValidationComplete(false);
    setValidationError('');
    setExtractedProducts([]);
    setValidProducts([]);
    setInvalidProducts([]);
    setValidProductsWithDescriptions({});
    setDuplicatesMessage('');
    setProgressPercentage(0);
    setProgressInfo({ processed: 0, total: 0, originalTotal: 0, currentBatch: 0, totalBatches: 0 });
  };

  const validateStoresFromCsv = async (branchCodes) => {
    if (!branchCodes || branchCodes.length === 0) {
      failInvalidStoresValidation();
      return false;
    }

    try {
      const result = await validateBranches(branchCodes);
      const invalidCount = Object.keys(result?.invalidBranches || {}).length;
      if (invalidCount > 0) {
        failInvalidStoresValidation();
        return false;
      }
      return true;
    } catch (error) {
      failInvalidStoresValidation();
      return false;
    }
  };

  const validateProductsOnUpload = async (products, duplicatesRemoved = 0, originalTotal = 0) => {
    if (!products || products.length === 0) {
      setValidationComplete(true);
      setTimeout(() => {
        setLoadingCsv(false);
      }, 1500);
      return;
    }

    setProgressPercentage(0);
    setProgressInfo({ processed: 0, total: products.length, originalTotal: originalTotal || products.length, currentBatch: 0, totalBatches: 0 });

    try {
      const handleProgress = (progressData) => {
        setProgressPercentage(progressData.percentage);
        setProgressInfo({
          processed: progressData.processed,
          total: progressData.total,
          originalTotal: originalTotal || products.length,
          currentBatch: progressData.currentBatch,
          totalBatches: progressData.totalBatches
        });
      };

      const response = await validateProducts(products, handleProgress);
      const valid = response?.validProducts ? Object.keys(response.validProducts) : [];
      const invalid = response?.invalidProducts ? Object.keys(response.invalidProducts) : [];
      const productsWithDescriptions = response?.validProducts || {};
      setValidProductsWithDescriptions(productsWithDescriptions);
      setValidProducts(valid);
      setInvalidProducts(invalid);
      setShowValidationResults(true);
      setValidationComplete(true);

      setProgressPercentage(100);

      if (duplicatesRemoved > 0) {
        const duplicateMessage = duplicatesRemoved === 1
          ? `${duplicatesRemoved} LM duplicado foi removido automaticamente.`
          : `${duplicatesRemoved} LMs duplicados foram removidos automaticamente.`;
        setDuplicatesMessage(duplicateMessage);
      } else {
        setDuplicatesMessage('');
      }

      setTimeout(() => {
        setLoadingCsv(false);
        setProgressPercentage(0);
        setProgressInfo({ processed: 0, total: 0, currentBatch: 0, totalBatches: 0 });
      }, 1000);
    } catch (error) {
      setValidationError(translate('price.banner.error.validation.products'));
      setShowValidationResults(true);
      setValidationComplete(true);
      setProgressPercentage(100);
      setTimeout(() => {
        setLoadingCsv(false);
        setProgressPercentage(0);
        setProgressInfo({ processed: 0, total: 0, currentBatch: 0, totalBatches: 0 });
      }, 1000);
    }
  };

  const handleRetryFailedProducts = async () => {
    if (!invalidProducts || invalidProducts.length === 0) {
      return;
    }

    setRetryLoading(true);
    setValidationError('');
    setLoadingCsv(true);
    setValidationComplete(false);
    setProgressPercentage(0);
    setProgressInfo({ processed: 0, total: invalidProducts.length, originalTotal: invalidProducts.length, currentBatch: 0, totalBatches: 0 });

    try {
      const handleProgress = (progressData) => {
        setProgressPercentage(progressData.percentage);
        setProgressInfo({
          processed: progressData.processed,
          total: progressData.total,
          originalTotal: invalidProducts.length,
          currentBatch: progressData.currentBatch,
          totalBatches: progressData.totalBatches
        });
      };

      const response = await validateProducts(invalidProducts, handleProgress);
      const valid = response?.validProducts ? Object.keys(response.validProducts) : [];
      const invalid = response?.invalidProducts ? Object.keys(response.invalidProducts) : [];
      const productsWithDescriptions = response?.validProducts || {};
      
      const newValidProducts = [...validProducts, ...valid];
      const newValidProductsWithDescriptions = { ...validProductsWithDescriptions, ...productsWithDescriptions };
      
      setValidProductsWithDescriptions(newValidProductsWithDescriptions);
      setValidProducts(newValidProducts);
      setInvalidProducts(invalid);
      setShowValidationResults(true);
      setValidationComplete(true);
      setProgressPercentage(100);
      
      setTimeout(() => {
        setRetryLoading(false);
        setLoadingCsv(false);
        setProgressPercentage(0);
        setProgressInfo({ processed: 0, total: 0, originalTotal: 0, currentBatch: 0, totalBatches: 0 });
      }, 1000);
    } catch (error) {
      setValidationError(translate('price.banner.error.validation.products'));
      setShowValidationResults(true);
      setValidationComplete(true);
      setProgressPercentage(100);
      setTimeout(() => {
        setRetryLoading(false);
        setLoadingCsv(false);
        setProgressPercentage(0);
        setProgressInfo({ processed: 0, total: 0, originalTotal: 0, currentBatch: 0, totalBatches: 0 });
      }, 1000);
    }
  };

  const handleConfirm = async () => {
    const newErr = {
      list: !selectedList || !selectedList.value,
      file: !uploadedFile
    };
    const hasError = newErr.list || newErr.file;
    if (!user?.username || !user?.fullName) {
      setValidationError(translate('application.fatal.error'));
      return;
    }
    if (hasError) {
      setErrors(newErr);
      return;
    }
    if (showValidationResults && validProducts.length === 0) {
      return;
    }
    const finalProductLms = showValidationResults && validProducts.length > 0 ? validProducts : extractedProducts;
    const finalProductDescriptions = showValidationResults && Object.keys(validProductsWithDescriptions).length > 0
      ? validProductsWithDescriptions
      : {};
    
    const productExtrasStorageKey = getProductExtrasStorageKeyByTheme(listThemeCode);
    const storedExtras = productExtrasStorageKey ? sessionStorage.getItem(productExtrasStorageKey) : null;
    const productExtrasRaw = storedExtras ? JSON.parse(storedExtras) : {};
    
    // Filter extras to include only valid products
    const branchMaps = filterBranchMapsForProductLms(
      {
        productBranchesByLm,
        productBranchExtrasByLm,
        productExtrasByLm: productExtrasRaw,
      },
      finalProductLms
    );

    const metadata = {
      listId: selectedList.value,
      listName: selectedList.label,
      productLms: finalProductLms,
      productDescriptions: finalProductDescriptions,
      cdLdap: user?.username || '',
      dsLdap: user?.fullName || '',
      dtStart: selectedList.dtStart,
      dtEnd: selectedList.dtEnd,
      ...(Object.keys(branchMaps.productExtrasByLm).length > 0 && {
        productExtrasByLm: branchMaps.productExtrasByLm,
      }),
      ...(Object.keys(branchMaps.productBranchesByLm).length > 0 && {
        productBranchesByLm: branchMaps.productBranchesByLm,
      }),
      ...(Object.keys(branchMaps.productBranchExtrasByLm).length > 0 && {
        productBranchExtrasByLm: branchMaps.productBranchExtrasByLm,
      }),
      ...(branchesFromFile.length > 0 && { idBranchesFromFile: branchesFromFile }),
    };
    onSave && onSave(metadata, null);
  };
  const handleFileUpload = (files) => {
    setErrorOnStruct(false);
    setValidationError('');
    setShowValidationResults(false);
    setValidationComplete(false);
    setValidProducts([]);
    setInvalidProducts([]);
    setValidProductsWithDescriptions({});
    try {
      sessionStorage.removeItem(CMPM_PRODUCT_EXTRAS_STORAGE_KEY);
      sessionStorage.removeItem(CLUBE_LEROY_PRODUCT_EXTRAS_STORAGE_KEY);
    } catch (e) {
      // ignore
    }
    const file = files[0];
    if (validateCsv(file)) {
      setUploadedFile(file);
      setCleanFile(false);
      setIsValidCsv(true);
      setTimeout(() => {
        readCsv(file);
      }, 100);
      setErrors(e => ({ ...e, file: false }));
    } else {
      setIsValidCsv(false);
      setErrors(e => ({ ...e, file: true }));
    }
  };

  const handleRemoveUploadedFile = () => {
    setUploadedFile(null);
    setIsValidCsv(null);
    setErrorText('');
    setErrorOnStruct(false);
    setLoadingCsv(false);
    setRetryLoading(false);
    setShowValidationResults(false);
    setValidationError('');
    setExtractedProducts([]);
    setInvalidProducts([]);
    setValidProducts([]);
    setValidProductsWithDescriptions({});
    setDuplicatesMessage('');
    setProgressPercentage(0);
    setProgressInfo({
      processed: 0,
      total: 0,
      originalTotal: 0,
      currentBatch: 0,
      totalBatches: 0
    });
    setCleanFile(true);
    try {
      sessionStorage.removeItem(CMPM_PRODUCT_EXTRAS_STORAGE_KEY);
      sessionStorage.removeItem(CLUBE_LEROY_PRODUCT_EXTRAS_STORAGE_KEY);
    } catch (e) {
      // ignore
    }
    setBranchesFromFile([]);
    setProductBranchesByLm({});
    setProductBranchExtrasByLm({});
    setErrors(e => ({ ...e, file: false }));
  };
  const handleDownloadTemplate = () => {
    if (!selectedList || !selectedList.value) return
    const { content: model, filename } = getAddProductCsvTemplate(listThemeCode);

    const csvData = new Blob([model], { type: 'text/csv;charset=utf-8;' });
    let csvURL = null;
    if (navigator.msSaveBlob) {
      csvURL = navigator.msSaveBlob(csvData, filename);
    } else {
      csvURL = window.URL.createObjectURL(csvData);
    }

    const tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', filename);
    tempLink.click();
  };

  const handleCloseModal = () => {
    onOpenChange(false);
  };

  return (
    <>
      <style>
        {`
          @keyframes loading-shimmer {
            0% { background-position: -200% 0; }
            100% { background-position: 200% 0; }
          }
        `}
      </style>
      <Modal
      title={title || translate('price.banner.addproductslist')}
      size="md"
      isOpen={open}
      onCloseModal={handleCloseModal}
      useControlledState
      className="price-banner-add-product-modal"
      showFooter={true}
      hideCancelButton={false}
      cancelButtonText={translate('price.banner.downloadtemplate')}
      confirmButtonText={translate('save_button_label')}
      onConfirm={handleConfirm}
      onCancelButtonClick={handleDownloadTemplate}
      isCancelButtonDisabled={!(selectedList && selectedList.value)}
      isConfirmButtonDisabled={Object.values(errors).some(error => error) || loadingCsv || retryLoading || errorOnStruct || !isValidCsv || (!showValidationResults && isValidCsv) || (showValidationResults && validProducts.length === 0)}
      noCloseOnConfirm
    >
      <div className="w-100">
        <div className="w-100">
          <ListSelectField
            label={translate('price.banner.listname')}
            placeholder="Selecione uma lista"
            value={selectedList}
            onChange={v => {
              setSelectedList(v);
              setListThemeCode(v?.fullData?.themeCode || null);
              setErrors(e => ({ ...e, list: false }));
            }}
            required
            errorText={errors.list ? translate('mandatory') : undefined}
            showHelperArea={false}
            validateValue={(value) => !!value?.value}
            user={user}
            disabled={(new URLSearchParams(window.location.search).get('listId') !== null)}
            fill
            showAllOption={false}
            showTheme={true}
          />
        </div>
        <div className="w-100 custom-height-input">
          {loadingCsv && (
            <div className={`loading-status margin-bottom ${validationComplete ? 'complete' : 'loading'}`} style={{ '--default-bar-width': '0%' }}>
                <span style={{ 
                  fontWeight: '600',
                  color: validationComplete ? '#fff' : '#dcf5dc'
                }}>
                  {validationComplete
                    ? 'Carregamento completo'
                    : `${translate('loading')} ${progressInfo.processed} / ${progressInfo.originalTotal}`
                  }
                </span>
                <div
                  className={`bar ${!validationComplete ? 'loading' : 'complete'}`}
                  style={{
                    width: `${validationComplete ? 100 : Math.max(progressPercentage, 2)}%`,
                    transition: validationComplete ? 'width 0.3s ease-in-out' : 'width 0.2s ease-out',
                    background: validationComplete
                      ? '#41a017'
                      : 'linear-gradient(90deg, #41a017 0%, #52b91f 50%, #41a017 100%)',
                    backgroundSize: validationComplete ? '100% 100%' : '200% 100%',
                    animation: validationComplete ? 'none' : 'loading-shimmer 2s infinite'
                  }}
                />
              </div>
          )}
          <FileInput
            cleanFile={cleanFile}
            resetValue
            required
            errorOnStruct={errorOnStruct}
            successText={loadingCsv ? 'Carregando arquivo...' : 'Arquivo carregado com sucesso!'}
            validateValue={(f) => f[0].type === 'text/csv' && f[0].size <= 5 * 1024 * 1024 && f[0].size > 0}
            errorText={errorText}
            disabled={!(selectedList && selectedList.value) || loadingCsv}
            placeholder="Escolha um arquivo"
            hideFileInput={loadingCsv}
            className="custom-height-input"
            helpText={translate('price.banner.file.help')}
            accept={'.csv'}
            onChange={handleFileUpload}
            showClearFile={!!uploadedFile}
            onClearFile={handleRemoveUploadedFile}
            label={translate('price.banner.attachfile')}
            name="file"
          />
        </div>
        {showValidationResults && validProducts.length > 0 && invalidProducts.length > 0 && !loadingCsv && (
          <div className="w-100">
            <SupplyItemsNotFoundBox
              topMsg="Os seguintes produtos não foram encontrados e não serão considerados quando a lista for salva:"
              bottomMsg={duplicatesMessage}
              items={invalidProducts}
              showRetryButton={true}
              onRetry={handleRetryFailedProducts}
              retryLoading={retryLoading}
              translate={translate}
            />
          </div>
        )}
        {showValidationResults && validProducts.length === 0 && invalidProducts.length > 0 && (
          <div className="w-100">
            <SupplyItemsNotFoundBox
              error
              topMsg="Nenhum produto foi encontrado. Ajuste os produtos do arquivo e refaça o upload."
              bottomMsg={duplicatesMessage}
              items={invalidProducts}
            />
          </div>
        )}
        {showValidationResults && validProducts.length > 0 && invalidProducts.length === 0 && duplicatesMessage && (
          <div className="w-100">
            <SupplyItemsNotFoundBox
              topMsg="Produtos validados com sucesso!"
              bottomMsg={duplicatesMessage}
              items={[]}
            />
          </div>
        )}
        {validationError && (
          <div className="w-100">
            <SupplyItemsNotFoundBox
              error
              topMsg={translate('price.banner.error.validation.products')}
              bottomMsg=""
              items={[]}
            />
          </div>
        )}
      </div>
    </Modal>
    </>
  );
}
AddProductModal.propTypes = {
  title: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  user: PropTypes.object,
  initialData: PropTypes.object,
  validateProducts: PropTypes.func.isRequired,
  validateBranches: PropTypes.func.isRequired,
  listName: PropTypes.string,
  translate: PropTypes.func.isRequired
};
const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => bindActionCreators({
  validateProducts: pricebannerListActions.validateProducts,
  validateBranches: pricebannerListActions.validateBranches
}, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate(null, { wait: true, translateFuncName: 'translate' })(AddProductModal));
